import BOX_PROVIDER from './providers/box'
import DROPBOX_PROVIDER from './providers/dropbox'
import type { UploadProvider } from 'types/upload'
export const UPLOAD_PROVIDERS: UploadProvider[] = [
  BOX_PROVIDER,
  DROPBOX_PROVIDER
]
